module.exports = __webpack_public_path__ + "f25df89b651628de007e58bb38318c35.gif";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/book.gif
// module id = 1535
// module chunks = 0